import { CredentialEntity, ZohoCredentialToCredentialEntityMapper } from '@uploadcam/common';
import { ExchangeAuthCodeInteractor } from '../../auth/domain/interactors/exchange-auth-code.interactor';

export class ExchangeZohoAuthCodeInteractor implements ExchangeAuthCodeInteractor {
  public async execute(
    _code: string,
    _verifier: string,
    _isPopup: boolean,
    metadata?: Record<string, any>,
  ): Promise<CredentialEntity> {
    // Client-based application (implicit flow): tokens come back in the URL fragment, not via
    // a server-side code exchange. `metadata` carries every field we need.
    // `accounts_server` is only sent under the code flow — implicit flow omits it, and we don't
    // need it (no server-side token exchange or refresh).
    const accessToken = metadata?.['access_token'];
    const expiresIn = metadata?.['expires_in'];
    const apiDomain = metadata?.['api_domain'];
    const accountsServer = metadata?.['accounts_server'];
    const scope = metadata?.['scope'];

    if (typeof accessToken !== 'string' || accessToken.length === 0) {
      throw new Error('Zoho access_token missing from OAuth fragment');
    }
    if (typeof apiDomain !== 'string' || apiDomain.length === 0) {
      throw new Error('Zoho api_domain missing from OAuth fragment');
    }
    if (typeof scope !== 'string' || scope.length === 0) {
      throw new Error('Zoho scope missing from OAuth fragment');
    }

    const expiresInNum = Number(expiresIn);
    if (!Number.isFinite(expiresInNum) || expiresInNum <= 0) {
      throw new Error('Zoho expires_in missing or invalid');
    }

    const mapper = new ZohoCredentialToCredentialEntityMapper(Date.now());
    return mapper.map({
      access_token: accessToken,
      expires_in: expiresInNum,
      scope,
      api_domain: apiDomain,
      accounts_server: typeof accountsServer === 'string' ? accountsServer : undefined,
    });
  }
}
